import {$invoiceState} from '../../models/common';
import {
    InfoValues,
    InvoiceTypeCodeStatus,
    InvoiceTypeCodeStatusInfo,
    PageValues,
    TaxesAndTotal,
} from '../../types/invoices';

import {formatDateToDDMMYYYY} from './buildXml';

export const setDocumentBase = (
    params: InvoiceTypeCodeStatusInfo,
    infoValues: InfoValues,
    taxesAndTotal: TaxesAndTotal,
    pageValues: PageValues,
    CURRENCY: string,
) => {
    if (
        params.label === InvoiceTypeCodeStatus.ANNULLING ||
        params.label === InvoiceTypeCodeStatus.CORRECTIVE_ANNULLING ||
        params.label === InvoiceTypeCodeStatus.DIRECT_ANNULLING
    ) {
        return {
            '@_xmlns:cac':
                'urn:oasis:names:specification:ubl:schema:xsd:CommonAggregateComponents-2',
            '@_xmlns:cbc': 'urn:oasis:names:specification:ubl:schema:xsd:CommonBasicComponents-2',
            '@_xmlns': 'urn:oasis:names:specification:ubl:schema:xsd:CreditNote-2',
            'cbc:CustomizationID':
                'urn:cen.eu:en16931:2017#compliant#urn:fdc:peppol.eu:2017:poacc:billing:3.0',
            'cbc:ProfileID': 'urn:fdc:peppol.eu:2017:poacc:billing:01:1.0',
            'cbc:ID': infoValues.irn,
            'cbc:IssueDate': formatDateToDDMMYYYY(infoValues.issueDate),
            'cbc:TaxPointDate': formatDateToDDMMYYYY(pageValues.taxPointDate),
            'cbc:CreditNoteTypeCode': params.code,
            'cbc:Note': taxesAndTotal.withholdingTax,
            'cbc:DocumentCurrencyCode': CURRENCY,
            'cbc:BuyerReference': pageValues.buyerReference,
            'cac:InvoicePeriod': {
                'cbc:StartDate': formatDateToDDMMYYYY(pageValues.periodFrom),
                'cbc:EndDate': formatDateToDDMMYYYY(pageValues.periodTo),
            },
            ...(pageValues.purchaseOrderReference && {
                'cac:OrderReference': {
                    'cbc:ID': pageValues.purchaseOrderReference,
                    'cbc:SalesOrderID': pageValues.salesOrderReference,
                },
            }),
            'cac:BillingReference': {
                'cac:InvoiceDocumentReference': {
                    'cbc:ID': $invoiceState.getState(),
                },
            },
        };
    } else {
        return {
            '@_xmlns:cac':
                'urn:oasis:names:specification:ubl:schema:xsd:CommonAggregateComponents-2',
            '@_xmlns:cbc': 'urn:oasis:names:specification:ubl:schema:xsd:CommonBasicComponents-2',
            '@_xmlns': 'urn:oasis:names:specification:ubl:schema:xsd:Invoice-2',
            'cbc:CustomizationID':
                'urn:cen.eu:en16931:2017#compliant#urn:fdc:peppol.eu:2017:poacc:billing:3.0',
            'cbc:ProfileID': 'urn:fdc:peppol.eu:2017:poacc:billing:01:1.0',
            'cbc:ID': infoValues.irn,
            'cbc:IssueDate': formatDateToDDMMYYYY(infoValues.issueDate),
            'cbc:DueDate': formatDateToDDMMYYYY(infoValues.dueDate),
            'cbc:InvoiceTypeCode': params.code,
            'cbc:Note': taxesAndTotal.withholdingTax,
            'cbc:TaxPointDate': formatDateToDDMMYYYY(pageValues.taxPointDate),
            'cbc:DocumentCurrencyCode': CURRENCY,
            'cbc:BuyerReference': pageValues.buyerReference,
            'cac:InvoicePeriod': {
                'cbc:StartDate': formatDateToDDMMYYYY(pageValues.periodFrom),
                'cbc:EndDate': formatDateToDDMMYYYY(pageValues.periodTo),
            },
            ...(pageValues.purchaseOrderReference && {
                'cac:OrderReference': {
                    'cbc:ID': pageValues.purchaseOrderReference,
                    'cbc:SalesOrderID': pageValues.salesOrderReference,
                },
            }),
            ...(params.label === InvoiceTypeCodeStatus.CORRECTIVE_BASIC && {
                'cac:BillingReference': {
                    'cac:InvoiceDocumentReference': {
                        'cbc:ID': $invoiceState.getState(),
                    },
                },
            }),
        };
    }
};
